import { render, staticRenderFns } from "./CreateStockTransferModal.vue?vue&type=template&id=7ffe8dcf"
import script from "./CreateStockTransferModal.vue?vue&type=script&lang=js"
export * from "./CreateStockTransferModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports